/**
 * Client-side check: can the current user send from this mailbox?
 *
 * Mailbox shape (from GET /emails/mailboxes):
 *   { send_restriction: 'all' | 'admin_only' | 'specific_users',
 *     permitted_user_ids: number[] }
 *
 * Super Admin/Admin always allowed.
 */
export function canUserSendFromMailbox(mailbox, user) {
  if (!mailbox) return false;
  const role = String(user?.role || '').toLowerCase();
  if (['super_admin', 'admin'].includes(role)) return true;
  if (mailbox.send_restriction === 'admin_only') return false;
  if (mailbox.send_restriction === 'specific_users') {
    const ids = mailbox.permitted_user_ids || [];
    return ids.includes(user?.user_id);
  }
  return true;
}
